import { Link } from "react-router-dom"

// 💡 1. 백엔드 데이터(DTO)에 맞춰 타입 확장
type Product = {
  productId: number | string
  productName: string
  price?: number | string
  badge?: string             // 예: "BEST", "NEW" 등
  thumbnailUrl: string
  isFreeShipping?: boolean   // 무료배송 여부 (true/false)
  rating?: number            // 별점 (예: 4.8)
  reviewCount?: number       // 리뷰 건수 (예: 1234)
}

type ProductCardProps = {
  product: Product
}

export default function ProductCard({ product }: ProductCardProps) {
  // 💡 2. 금액 천 단위 콤마 변환 함수
  const formatPrice = (price: any) => {
    if (!price) return "0";
    // 문자로 넘어오든 숫자로 넘어오든 숫자만 추출하여 콤마 처리
    const numericPrice = Number(price.toString().replace(/[^0-9]/g, ""));
    return numericPrice.toLocaleString();
  };

  return (
    <div className="group cursor-pointer">
      <Link to={`/product/${product.productId}`}>
        <div className="relative aspect-square overflow-hidden rounded-[16px] border border-slate-200 bg-white">
          <img
            src={product.thumbnailUrl}
            alt={product.productName}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {/* 장바구니 버튼 */}
          <button className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-slate-900/40 text-white backdrop-blur transition-colors hover:bg-rose-500">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-5 w-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
            </svg>
          </button>
        </div>
      </Link>

      {/* 하단 정보 영역 */}
      <div className="mt-4 px-1">
        {/* 💡 3. 실제 배지 및 무료배송 데이터 연동 */}
        <div className="flex gap-1 mb-1.5 min-h-[20px]">
          {product.badge && (
            <span className="rounded bg-rose-500 px-1.5 py-0.5 text-[10px] font-bold text-white">
                        {product.badge}
                    </span>
          )}
          {product.isFreeShipping && (
            <span className="rounded border border-slate-300 px-1.5 py-0.5 text-[10px] font-bold text-slate-500">
                        무료배송
                    </span>
          )}
        </div>

        <Link to={`/product/${product.productId}`}>
          <h3 className="line-clamp-2 text-[15px] font-medium leading-snug text-slate-800 group-hover:underline">
            {product.productName}
          </h3>
        </Link>

        {/* 💡 4. 금액 콤마 처리 적용 */}
        <div className="mt-2 flex items-baseline gap-1">
                    <span className="text-[19px] font-extrabold tracking-tight text-slate-900">
                        {formatPrice(product.price)}원
                    </span>
        </div>

        {/* 💡 5. 실제 별점 및 후기 건수 연동 */}
        <div className="mt-2 flex items-center gap-2 text-[12px] font-medium text-slate-500">
          <div className="flex items-center gap-0.5 text-yellow-500">
            <span>★</span>
            {/* 별점이 있으면 소수점 1자리까지 표시, 없으면 0.0 */}
            <span className="text-slate-700">
                          {product.rating ? product.rating.toFixed(1) : "0.0"}
                      </span>
          </div>
          <span className="h-2.5 w-px bg-slate-300"></span>
          <span>
                      후기 <b className="text-slate-700">
                          {/* 후기 건수도 콤마 처리 */}
            {product.reviewCount ? product.reviewCount.toLocaleString() : "0"}
                      </b>
                  </span>
        </div>
      </div>
    </div>
  )
}